{
  "version": "1.0.0",
  "generatedAt": "2026-08-29",
  "totalEnemies": 35,
  "totalSpriteFrames": 4112,
  "categories": [
    "infantry",
    "heavy",
    "flying",
    "turret",
    "boss",
    "fauna"
  ],
  "enemies": [
    {
      "id": "blue",
      "name": "BLUE INFILTRATOR",
      "category": "infantry",
      "archetype": "cyborg-trooper",
      "worldSizeRaw": 7.0,
      "dimensionsMeters": [
        1.07,
        1.26,
        0.2
      ],
      "maxDimensionMeters": 1.26,
      "pedestalFitScale": 1.0,
      "hp": 85,
      "maxHp": 85,
      "speed": 4,
      "moveSpeed": 4,
      "attackDamage": 15,
      "fireRate": 1.2,
      "attackRange": 14,
      "projectileType": "bullet",
      "projectileSpeed": 35,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": false,
      "color": 35071,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 50
        },
        {
          "item": "spread-ammo",
          "weight": 30
        },
        {
          "item": "energy-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "stealth_cyan",
        "shadow_blue"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_blue_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_blue.png",
        "frameCount": 88,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "attack": {
            "startRow": 9,
            "frameCount": 1,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 10,
            "frameCount": 1,
            "fps": 6.0
          },
          "death": {
            "startRow": 10,
            "frameCount": 1,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 11,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : blue.e3 (world_size: 7.0)",
        "textureParts": [
          {
            "name": "blu_gun",
            "width": 64,
            "height": 64
          },
          {
            "name": "blu_head",
            "width": 64,
            "height": 64
          },
          {
            "name": "blu_tors",
            "width": 64,
            "height": 64
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\blue.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "carrier",
      "name": "AUTOMATED VEHICLE CARRIER",
      "category": "heavy",
      "archetype": "heavy_enforcer",
      "worldSizeRaw": 6.5,
      "dimensionsMeters": [
        1.87,
        2.2,
        0.2
      ],
      "maxDimensionMeters": 2.2,
      "pedestalFitScale": 1.0,
      "hp": 350,
      "maxHp": 350,
      "speed": 3,
      "moveSpeed": 3,
      "attackDamage": 20,
      "fireRate": 1,
      "attackRange": 8,
      "projectileType": "heavy-shot",
      "projectileSpeed": 30,
      "shieldCapacity": 100,
      "hasRiotShield": true,
      "isFlying": false,
      "isTurret": false,
      "color": 3359829,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 40
        },
        {
          "item": "missile-ammo",
          "weight": 35
        },
        {
          "item": "reserve-tank",
          "weight": 15
        },
        {
          "item": "keycard-blue",
          "weight": 10
        }
      ],
      "swatches": [
        "standard",
        "naval_blue",
        "arctic_white"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_carrier_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_carrier.png",
        "frameCount": 88,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "attack": {
            "startRow": 9,
            "frameCount": 2,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "death": {
            "startRow": 9,
            "frameCount": 2,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 11,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : carrier.e3 (world_size: 6.5)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\carrier.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "constbot",
      "name": "CONSTRUCTION SECURITY BOT",
      "category": "heavy",
      "archetype": "heavy_enforcer",
      "worldSizeRaw": 10.0,
      "dimensionsMeters": [
        1.87,
        2.2,
        0.2
      ],
      "maxDimensionMeters": 2.2,
      "pedestalFitScale": 1.0,
      "hp": 260,
      "maxHp": 260,
      "speed": 3,
      "moveSpeed": 3,
      "attackDamage": 20,
      "fireRate": 1,
      "attackRange": 8,
      "projectileType": "heavy-shot",
      "projectileSpeed": 30,
      "shieldCapacity": 100,
      "hasRiotShield": true,
      "isFlying": false,
      "isTurret": false,
      "color": 13404160,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 40
        },
        {
          "item": "missile-ammo",
          "weight": 35
        },
        {
          "item": "reserve-tank",
          "weight": 15
        },
        {
          "item": "keycard-blue",
          "weight": 10
        }
      ],
      "swatches": [
        "standard",
        "industrial_yellow",
        "rust_orange"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_constbot_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_constbot.png",
        "frameCount": 152,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "attack": {
            "startRow": 9,
            "frameCount": 4,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 13,
            "frameCount": 1,
            "fps": 6.0
          },
          "death": {
            "startRow": 18,
            "frameCount": 1,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 19,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : constbot.e3 (world_size: 10.0)",
        "textureParts": [
          {
            "name": "cnst_arm",
            "width": 64,
            "height": 64
          },
          {
            "name": "cnst_leg",
            "width": 64,
            "height": 64
          },
          {
            "name": "cnst_shr",
            "width": 64,
            "height": 64
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\constbot.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "crimson",
      "name": "CRIMSON SIEGE ENFORCER",
      "category": "heavy",
      "archetype": "heavy_enforcer",
      "worldSizeRaw": 9.0,
      "dimensionsMeters": [
        1.87,
        2.2,
        0.2
      ],
      "maxDimensionMeters": 2.2,
      "pedestalFitScale": 1.0,
      "hp": 280,
      "maxHp": 280,
      "speed": 3,
      "moveSpeed": 3,
      "attackDamage": 20,
      "fireRate": 1,
      "attackRange": 8,
      "projectileType": "heavy-shot",
      "projectileSpeed": 30,
      "shieldCapacity": 100,
      "hasRiotShield": true,
      "isFlying": false,
      "isTurret": false,
      "color": 8917282,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 40
        },
        {
          "item": "missile-ammo",
          "weight": 35
        },
        {
          "item": "reserve-tank",
          "weight": 15
        },
        {
          "item": "keycard-blue",
          "weight": 10
        }
      ],
      "swatches": [
        "standard",
        "blood_crimson",
        "magma_red"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_crimson_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_crimson.png",
        "frameCount": 96,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "attack": {
            "startRow": 9,
            "frameCount": 1,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 10,
            "frameCount": 1,
            "fps": 6.0
          },
          "death": {
            "startRow": 11,
            "frameCount": 1,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 12,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : crimson.e3 (world_size: 9.0)",
        "textureParts": [
          {
            "name": "crim_arm",
            "width": 64,
            "height": 64
          },
          {
            "name": "crim_hed",
            "width": 64,
            "height": 64
          },
          {
            "name": "crimches",
            "width": 64,
            "height": 64
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\crimson.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "derby",
      "name": "DERBY RECON COMBATANT",
      "category": "infantry",
      "archetype": "patrol_guard",
      "worldSizeRaw": 7.0,
      "dimensionsMeters": [
        1.07,
        1.26,
        0.2
      ],
      "maxDimensionMeters": 1.26,
      "pedestalFitScale": 1.0,
      "hp": 80,
      "maxHp": 80,
      "speed": 4,
      "moveSpeed": 4,
      "attackDamage": 15,
      "fireRate": 1.2,
      "attackRange": 14,
      "projectileType": "bullet",
      "projectileSpeed": 35,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": false,
      "color": 5596791,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 50
        },
        {
          "item": "spread-ammo",
          "weight": 30
        },
        {
          "item": "energy-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "tactical_grey",
        "olive_drab"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_derby_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_derby.png",
        "frameCount": 40,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 4,
            "fps": 8.0
          },
          "run": {
            "startRow": 1,
            "frameCount": 4,
            "fps": 8.0
          },
          "attack": {
            "startRow": 1,
            "frameCount": 4,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "death": {
            "startRow": 1,
            "frameCount": 4,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 256,
        "frameHeight": 256,
        "sheetCols": 8,
        "sheetRows": 5,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : derby.e3 (world_size: 7.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\derby.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "dropship",
      "name": "TACTICAL AIRBORNE DROPSHIP",
      "category": "heavy",
      "archetype": "heavy_enforcer",
      "worldSizeRaw": 10.0,
      "dimensionsMeters": [
        1.87,
        2.2,
        0.2
      ],
      "maxDimensionMeters": 2.2,
      "pedestalFitScale": 1.0,
      "hp": 400,
      "maxHp": 400,
      "speed": 3,
      "moveSpeed": 3,
      "attackDamage": 20,
      "fireRate": 1,
      "attackRange": 8,
      "projectileType": "heavy-shot",
      "projectileSpeed": 30,
      "shieldCapacity": 100,
      "hasRiotShield": true,
      "isFlying": true,
      "isTurret": false,
      "color": 4478310,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 40
        },
        {
          "item": "missile-ammo",
          "weight": 35
        },
        {
          "item": "reserve-tank",
          "weight": 15
        },
        {
          "item": "keycard-blue",
          "weight": 10
        }
      ],
      "swatches": [
        "standard",
        "stealth_black",
        "desert_sand"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_dropship_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_dropship.png",
        "frameCount": 8,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "run": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "attack": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "death": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 1,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : dropship.e3 (world_size: 10.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\dropship.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "drrobo",
      "name": "DR. ROBO CYBERNETIC MECH",
      "category": "boss",
      "archetype": "boss_overlord",
      "worldSizeRaw": 20.0,
      "dimensionsMeters": [
        3.4,
        4.0,
        0.2
      ],
      "maxDimensionMeters": 4.0,
      "pedestalFitScale": 0.5,
      "hp": 500,
      "maxHp": 500,
      "speed": 3.5,
      "moveSpeed": 3.5,
      "attackDamage": 35,
      "fireRate": 4,
      "attackRange": 25,
      "projectileType": "plasma-burst",
      "projectileSpeed": 40,
      "shieldCapacity": 250,
      "hasRiotShield": true,
      "isFlying": false,
      "isTurret": false,
      "color": 8913083,
      "lootTable": [
        {
          "item": "reserve-tank",
          "weight": 40
        },
        {
          "item": "gyrex-ammo",
          "weight": 30
        },
        {
          "item": "keycard-red",
          "weight": 30
        }
      ],
      "swatches": [
        "standard",
        "royal_purple",
        "obsidian"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_drrobo_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_drrobo.png",
        "frameCount": 144,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "attack": {
            "startRow": 9,
            "frameCount": 4,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 13,
            "frameCount": 1,
            "fps": 6.0
          },
          "death": {
            "startRow": 14,
            "frameCount": 4,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 18,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : drrobo.e3 (world_size: 20.0)",
        "textureParts": [
          {
            "name": "robo_leg",
            "width": 64,
            "height": 64
          },
          {
            "name": "robobody",
            "width": 64,
            "height": 64
          },
          {
            "name": "robohead",
            "width": 64,
            "height": 64
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\drrobo.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "eel",
      "name": "ELECTRIC VOLTAIC EEL",
      "category": "fauna",
      "archetype": "melee_swarmer",
      "worldSizeRaw": 8.0,
      "dimensionsMeters": [
        1.02,
        1.2,
        0.2
      ],
      "maxDimensionMeters": 1.2,
      "pedestalFitScale": 1.0,
      "hp": 55,
      "maxHp": 55,
      "speed": 7,
      "moveSpeed": 7,
      "attackDamage": 12,
      "fireRate": 2,
      "attackRange": 3,
      "projectileType": "melee-strike",
      "projectileSpeed": 25,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": true,
      "isTurret": false,
      "color": 8978431,
      "lootTable": [
        {
          "item": "energy-tank",
          "weight": 60
        },
        {
          "item": "health-tank",
          "weight": 40
        }
      ],
      "swatches": [
        "standard",
        "electric_cyan",
        "volt_yellow"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_eel_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_eel.png",
        "frameCount": 64,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 4,
            "fps": 4.0
          },
          "walk": {
            "startRow": 4,
            "frameCount": 4,
            "fps": 8.0
          },
          "run": {
            "startRow": 4,
            "frameCount": 4,
            "fps": 8.0
          },
          "attack": {
            "startRow": 4,
            "frameCount": 4,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 4,
            "fps": 4.0
          },
          "death": {
            "startRow": 4,
            "frameCount": 4,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 8,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : eel.e3 (world_size: 8.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\eel.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "fbot",
      "name": "FBOT FLYING ASSAULT MECH",
      "category": "boss",
      "archetype": "boss_overlord",
      "worldSizeRaw": 20.0,
      "dimensionsMeters": [
        3.4,
        4.0,
        0.2
      ],
      "maxDimensionMeters": 4.0,
      "pedestalFitScale": 0.5,
      "hp": 450,
      "maxHp": 450,
      "speed": 3.5,
      "moveSpeed": 3.5,
      "attackDamage": 35,
      "fireRate": 4,
      "attackRange": 25,
      "projectileType": "plasma-burst",
      "projectileSpeed": 40,
      "shieldCapacity": 250,
      "hasRiotShield": true,
      "isFlying": true,
      "isTurret": false,
      "color": 13382400,
      "lootTable": [
        {
          "item": "reserve-tank",
          "weight": 40
        },
        {
          "item": "gyrex-ammo",
          "weight": 30
        },
        {
          "item": "keycard-red",
          "weight": 30
        }
      ],
      "swatches": [
        "standard",
        "solar_flare",
        "stealth_black"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_fbot_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_fbot.png",
        "frameCount": 120,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "attack": {
            "startRow": 9,
            "frameCount": 6,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "death": {
            "startRow": 9,
            "frameCount": 6,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 256,
        "frameHeight": 256,
        "sheetCols": 8,
        "sheetRows": 15,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : fbot.e3 (world_size: 20.0)",
        "textureParts": [
          {
            "name": "fbot_arm",
            "width": 64,
            "height": 64
          },
          {
            "name": "fbot_hip",
            "width": 64,
            "height": 64
          },
          {
            "name": "fbotbody",
            "width": 64,
            "height": 64
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\fbot.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "fire",
      "name": "PYRO KINETIC WISP",
      "category": "flying",
      "archetype": "melee_swarmer",
      "worldSizeRaw": 6.0,
      "dimensionsMeters": [
        0.77,
        0.9,
        0.2
      ],
      "maxDimensionMeters": 0.9,
      "pedestalFitScale": 1.0,
      "hp": 40,
      "maxHp": 40,
      "speed": 7,
      "moveSpeed": 7,
      "attackDamage": 12,
      "fireRate": 2,
      "attackRange": 3,
      "projectileType": "melee-strike",
      "projectileSpeed": 25,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": true,
      "isTurret": false,
      "color": 16729088,
      "lootTable": [
        {
          "item": "energy-tank",
          "weight": 60
        },
        {
          "item": "health-tank",
          "weight": 40
        }
      ],
      "swatches": [
        "standard",
        "plasma_fire",
        "blue_flame"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_fire_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_fire.png",
        "frameCount": 40,
        "states": [
          "idle",
          "walk",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4
          },
          "walk": {
            "startRow": 1,
            "frameCount": 1,
            "fps": 6
          },
          "attack": {
            "startRow": 2,
            "frameCount": 1,
            "fps": 6
          },
          "hurt": {
            "startRow": 3,
            "frameCount": 1,
            "fps": 6
          },
          "death": {
            "startRow": 4,
            "frameCount": 1,
            "fps": 6
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 5,
        "authenticDecoded": false
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : fire.e3 (world_size: 6.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": null,
        "huffmanDecoded": false
      }
    },
    {
      "id": "fish",
      "name": "MUTATED NATIVE FAUNA",
      "category": "fauna",
      "archetype": "fauna",
      "worldSizeRaw": 1.0,
      "dimensionsMeters": [
        0.77,
        0.9,
        0.2
      ],
      "maxDimensionMeters": 0.9,
      "pedestalFitScale": 1.0,
      "hp": 20,
      "maxHp": 20,
      "speed": 4,
      "moveSpeed": 4,
      "attackDamage": 15,
      "fireRate": 1.2,
      "attackRange": 14,
      "projectileType": "bullet",
      "projectileSpeed": 35,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": true,
      "isTurret": false,
      "color": 43775,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 50
        },
        {
          "item": "energy-tank",
          "weight": 30
        },
        {
          "item": "reserve-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "goldfish",
        "neon_tetra"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_fish_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_fish.png",
        "frameCount": 8,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "run": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "attack": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "death": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 1,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : fish.e3 (world_size: 1.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\fish.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "guardian",
      "name": "GUARDIAN BIPEDAL WAR MECH",
      "category": "heavy",
      "archetype": "heavy_enforcer",
      "worldSizeRaw": 12.0,
      "dimensionsMeters": [
        2.04,
        2.4,
        0.2
      ],
      "maxDimensionMeters": 2.4,
      "pedestalFitScale": 0.83,
      "hp": 300,
      "maxHp": 300,
      "speed": 3,
      "moveSpeed": 3,
      "attackDamage": 20,
      "fireRate": 1,
      "attackRange": 8,
      "projectileType": "heavy-shot",
      "projectileSpeed": 30,
      "shieldCapacity": 100,
      "hasRiotShield": true,
      "isFlying": false,
      "isTurret": false,
      "color": 5596740,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 40
        },
        {
          "item": "missile-ammo",
          "weight": 35
        },
        {
          "item": "reserve-tank",
          "weight": 15
        },
        {
          "item": "keycard-blue",
          "weight": 10
        }
      ],
      "swatches": [
        "standard",
        "forest_camo",
        "urban_titanium"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_guardian_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_guardian.png",
        "frameCount": 96,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "attack": {
            "startRow": 9,
            "frameCount": 1,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 10,
            "frameCount": 1,
            "fps": 6.0
          },
          "death": {
            "startRow": 11,
            "frameCount": 1,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 12,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : guardian.e3 (world_size: 12.0)",
        "textureParts": [
          {
            "name": "gurd_arm",
            "width": 64,
            "height": 64
          },
          {
            "name": "gurd_hed",
            "width": 64,
            "height": 64
          },
          {
            "name": "gurd_leg",
            "width": 64,
            "height": 64
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\guardian.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "heli",
      "name": "TACTICAL ATTACK GUNSHIP",
      "category": "flying",
      "archetype": "scout-drone",
      "worldSizeRaw": 30.0,
      "dimensionsMeters": [
        1.7,
        2.0,
        0.2
      ],
      "maxDimensionMeters": 2.0,
      "pedestalFitScale": 1.0,
      "hp": 320,
      "maxHp": 320,
      "speed": 6.5,
      "moveSpeed": 6.5,
      "attackDamage": 10,
      "fireRate": 2,
      "attackRange": 16,
      "projectileType": "energy",
      "projectileSpeed": 28,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": true,
      "isTurret": false,
      "color": 2245666,
      "lootTable": [
        {
          "item": "energy-tank",
          "weight": 60
        },
        {
          "item": "health-tank",
          "weight": 40
        }
      ],
      "swatches": [
        "standard",
        "army_green",
        "tiger_camo"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_heli_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_heli.png",
        "frameCount": 8,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "run": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "attack": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "death": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 256,
        "frameHeight": 256,
        "sheetCols": 8,
        "sheetRows": 1,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : heli.e3 (world_size: 30.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\heli.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "j5",
      "name": "J5 UTILITY RECON BOT",
      "category": "flying",
      "archetype": "scout-drone",
      "worldSizeRaw": 4.0,
      "dimensionsMeters": [
        0.77,
        0.9,
        0.2
      ],
      "maxDimensionMeters": 0.9,
      "pedestalFitScale": 1.0,
      "hp": 60,
      "maxHp": 60,
      "speed": 6.5,
      "moveSpeed": 6.5,
      "attackDamage": 10,
      "fireRate": 2,
      "attackRange": 16,
      "projectileType": "energy",
      "projectileSpeed": 28,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": true,
      "isTurret": false,
      "color": 16755200,
      "lootTable": [
        {
          "item": "energy-tank",
          "weight": 60
        },
        {
          "item": "health-tank",
          "weight": 40
        }
      ],
      "swatches": [
        "standard",
        "amber_gold",
        "neon_lime"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_j5_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_j5.png",
        "frameCount": 72,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 4,
            "fps": 8.0
          },
          "run": {
            "startRow": 1,
            "frameCount": 4,
            "fps": 8.0
          },
          "attack": {
            "startRow": 5,
            "frameCount": 4,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "death": {
            "startRow": 5,
            "frameCount": 4,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 9,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : j5.e3 (world_size: 4.0)",
        "textureParts": [
          {
            "name": "j5_arm",
            "width": 64,
            "height": 64
          },
          {
            "name": "j5_body",
            "width": 64,
            "height": 64
          },
          {
            "name": "j5_head",
            "width": 64,
            "height": 64
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\j5.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "jbk",
      "name": "JBK COMBAT FLYER",
      "category": "flying",
      "archetype": "scout-drone",
      "worldSizeRaw": 9.0,
      "dimensionsMeters": [
        1.15,
        1.35,
        0.2
      ],
      "maxDimensionMeters": 1.35,
      "pedestalFitScale": 1.0,
      "hp": 90,
      "maxHp": 90,
      "speed": 6.5,
      "moveSpeed": 6.5,
      "attackDamage": 10,
      "fireRate": 2,
      "attackRange": 16,
      "projectileType": "energy",
      "projectileSpeed": 28,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": true,
      "isTurret": false,
      "color": 52394,
      "lootTable": [
        {
          "item": "energy-tank",
          "weight": 60
        },
        {
          "item": "health-tank",
          "weight": 40
        }
      ],
      "swatches": [
        "standard",
        "emerald_green",
        "cobalt_blue"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_jbk_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_jbk.png",
        "frameCount": 88,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "attack": {
            "startRow": 9,
            "frameCount": 2,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "death": {
            "startRow": 9,
            "frameCount": 2,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 11,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : jbk.e3 (world_size: 9.0)",
        "textureParts": [
          {
            "name": "jbk_arm",
            "width": 64,
            "height": 64
          },
          {
            "name": "jbk_cpit",
            "width": 64,
            "height": 64
          },
          {
            "name": "jbk_hip",
            "width": 64,
            "height": 64
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\jbk.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "maqua",
      "name": "MAQUA AQUATIC PREDATOR",
      "category": "fauna",
      "archetype": "melee_swarmer",
      "worldSizeRaw": 10.0,
      "dimensionsMeters": [
        1.27,
        1.5,
        0.2
      ],
      "maxDimensionMeters": 1.5,
      "pedestalFitScale": 1.0,
      "hp": 110,
      "maxHp": 110,
      "speed": 7,
      "moveSpeed": 7,
      "attackDamage": 12,
      "fireRate": 2,
      "attackRange": 3,
      "projectileType": "melee-strike",
      "projectileSpeed": 25,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": true,
      "isTurret": false,
      "color": 34952,
      "lootTable": [
        {
          "item": "energy-tank",
          "weight": 60
        },
        {
          "item": "health-tank",
          "weight": 40
        }
      ],
      "swatches": [
        "standard",
        "seafoam_green",
        "coral_pink"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_maqua_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_maqua.png",
        "frameCount": 32,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 4,
            "fps": 4.0
          },
          "walk": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "run": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "attack": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 4,
            "fps": 4.0
          },
          "death": {
            "startRow": 0,
            "frameCount": 4,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 4,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : maqua.e3 (world_size: 10.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\maqua.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "mp1",
      "name": "MP1 PATROL TROOPER",
      "category": "infantry",
      "archetype": "patrol_guard",
      "worldSizeRaw": 6.5,
      "dimensionsMeters": [
        0.99,
        1.17,
        0.2
      ],
      "maxDimensionMeters": 1.17,
      "pedestalFitScale": 1.0,
      "hp": 80,
      "maxHp": 80,
      "speed": 4,
      "moveSpeed": 4,
      "attackDamage": 15,
      "fireRate": 1.2,
      "attackRange": 14,
      "projectileType": "bullet",
      "projectileSpeed": 35,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": false,
      "color": 9109504,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 50
        },
        {
          "item": "spread-ammo",
          "weight": 30
        },
        {
          "item": "energy-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "red_elite",
        "stealth_black"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_mp1_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_mp1.png",
        "frameCount": 160,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 9,
            "frameCount": 8,
            "fps": 10.0
          },
          "attack": {
            "startRow": 17,
            "frameCount": 1,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 18,
            "frameCount": 2,
            "fps": 6.0
          },
          "death": {
            "startRow": 18,
            "frameCount": 2,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 20,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : mp1.e3 (world_size: 6.5)",
        "textureParts": [
          {
            "name": "mp1deadb",
            "width": 256,
            "height": 256
          },
          {
            "name": "mp1deadf",
            "width": 256,
            "height": 256
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\mp1.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "mp1red",
      "name": "MP1 RED VANGUARD",
      "category": "infantry",
      "archetype": "patrol_guard",
      "worldSizeRaw": 6.5,
      "dimensionsMeters": [
        0.99,
        1.17,
        0.2
      ],
      "maxDimensionMeters": 1.17,
      "pedestalFitScale": 1.0,
      "hp": 95,
      "maxHp": 95,
      "speed": 4,
      "moveSpeed": 4,
      "attackDamage": 15,
      "fireRate": 1.2,
      "attackRange": 14,
      "projectileType": "bullet",
      "projectileSpeed": 35,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": false,
      "color": 13373713,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 50
        },
        {
          "item": "spread-ammo",
          "weight": 30
        },
        {
          "item": "energy-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "blood_red",
        "hazard_orange"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_mp1red_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_mp1red.png",
        "frameCount": 168,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 9,
            "frameCount": 8,
            "fps": 10.0
          },
          "attack": {
            "startRow": 17,
            "frameCount": 1,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 18,
            "frameCount": 2,
            "fps": 6.0
          },
          "death": {
            "startRow": 20,
            "frameCount": 1,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 21,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : mp1red.e3 (world_size: 6.5)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\mp1red.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "mp2",
      "name": "MP2 ASSAULT TROOPER",
      "category": "infantry",
      "archetype": "patrol_guard",
      "worldSizeRaw": 9.0,
      "dimensionsMeters": [
        1.38,
        1.62,
        0.2
      ],
      "maxDimensionMeters": 1.62,
      "pedestalFitScale": 1.0,
      "hp": 90,
      "maxHp": 90,
      "speed": 4,
      "moveSpeed": 4,
      "attackDamage": 15,
      "fireRate": 1.2,
      "attackRange": 14,
      "projectileType": "bullet",
      "projectileSpeed": 35,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": false,
      "color": 10824234,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 50
        },
        {
          "item": "spread-ammo",
          "weight": 30
        },
        {
          "item": "energy-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "urban_camo",
        "desert"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_mp2_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_mp2.png",
        "frameCount": 128,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 9,
            "frameCount": 5,
            "fps": 10.0
          },
          "attack": {
            "startRow": 14,
            "frameCount": 1,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 15,
            "frameCount": 1,
            "fps": 6.0
          },
          "death": {
            "startRow": 15,
            "frameCount": 1,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 16,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : mp2.e3 (world_size: 9.0)",
        "textureParts": [
          {
            "name": "mp2_gun",
            "width": 64,
            "height": 64
          },
          {
            "name": "mp2_hed",
            "width": 64,
            "height": 64
          },
          {
            "name": "mp2_leg",
            "width": 64,
            "height": 64
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\mp2.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "mp3",
      "name": "MP3 COMMANDO TROOPER",
      "category": "infantry",
      "archetype": "patrol_guard",
      "worldSizeRaw": 9.0,
      "dimensionsMeters": [
        1.38,
        1.62,
        0.2
      ],
      "maxDimensionMeters": 1.62,
      "pedestalFitScale": 1.0,
      "hp": 110,
      "maxHp": 110,
      "speed": 4,
      "moveSpeed": 4,
      "attackDamage": 15,
      "fireRate": 1.2,
      "attackRange": 14,
      "projectileType": "bullet",
      "projectileSpeed": 35,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": false,
      "color": 11674146,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 50
        },
        {
          "item": "spread-ammo",
          "weight": 30
        },
        {
          "item": "energy-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "spec_ops",
        "crimson"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_mp3_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_mp3.png",
        "frameCount": 80,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "attack": {
            "startRow": 9,
            "frameCount": 1,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "death": {
            "startRow": 9,
            "frameCount": 1,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 10,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : mp3.e3 (world_size: 9.0)",
        "textureParts": [
          {
            "name": "mp3_gun",
            "width": 64,
            "height": 64
          },
          {
            "name": "mp3_hed",
            "width": 64,
            "height": 64
          },
          {
            "name": "mp3_leg",
            "width": 64,
            "height": 64
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\mp3.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "probe",
      "name": "OPTICAL RECON PROBE",
      "category": "flying",
      "archetype": "scout-drone",
      "worldSizeRaw": 2.0,
      "dimensionsMeters": [
        0.77,
        0.9,
        0.2
      ],
      "maxDimensionMeters": 0.9,
      "pedestalFitScale": 1.0,
      "hp": 50,
      "maxHp": 50,
      "speed": 6.5,
      "moveSpeed": 6.5,
      "attackDamage": 10,
      "fireRate": 2,
      "attackRange": 16,
      "projectileType": "energy",
      "projectileSpeed": 28,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": true,
      "isTurret": false,
      "color": 65535,
      "lootTable": [
        {
          "item": "energy-tank",
          "weight": 60
        },
        {
          "item": "health-tank",
          "weight": 40
        }
      ],
      "swatches": [
        "standard",
        "neon_cyan",
        "pulsar_blue"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_probe_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_probe.png",
        "frameCount": 8,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "run": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "attack": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "death": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 64,
        "frameHeight": 64,
        "sheetCols": 8,
        "sheetRows": 1,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : probe.e3 (world_size: 2.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\probe.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "raven",
      "name": "RAVEN CYBORG ASSASSIN",
      "category": "infantry",
      "archetype": "cyborg-trooper",
      "worldSizeRaw": 6.5,
      "dimensionsMeters": [
        0.99,
        1.17,
        0.2
      ],
      "maxDimensionMeters": 1.17,
      "pedestalFitScale": 1.0,
      "hp": 100,
      "maxHp": 100,
      "speed": 4,
      "moveSpeed": 4,
      "attackDamage": 15,
      "fireRate": 1.2,
      "attackRange": 14,
      "projectileType": "bullet",
      "projectileSpeed": 35,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": false,
      "color": 3359846,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 50
        },
        {
          "item": "spread-ammo",
          "weight": 30
        },
        {
          "item": "energy-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "night_ops",
        "chrome"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_raven_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_raven.png",
        "frameCount": 720,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death",
          "crouch_idle",
          "crouch_walk",
          "crouch_run",
          "crouch_attack",
          "crouch_hurt",
          "swim_walk",
          "swim_attack",
          "swim_hurt",
          "swim_idle"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 4,
            "fps": 4.0
          },
          "walk": {
            "startRow": 4,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 12,
            "frameCount": 8,
            "fps": 10.0
          },
          "attack": {
            "startRow": 20,
            "frameCount": 7,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 27,
            "frameCount": 2,
            "fps": 6.0
          },
          "death": {
            "startRow": 84,
            "frameCount": 6,
            "fps": 6.0
          },
          "crouch_idle": {
            "startRow": 42,
            "frameCount": 1,
            "fps": 4.0
          },
          "crouch_walk": {
            "startRow": 43,
            "frameCount": 8,
            "fps": 8.0
          },
          "crouch_run": {
            "startRow": 51,
            "frameCount": 5,
            "fps": 10.0
          },
          "crouch_attack": {
            "startRow": 35,
            "frameCount": 7,
            "fps": 8.0
          },
          "crouch_hurt": {
            "startRow": 56,
            "frameCount": 2,
            "fps": 6.0
          },
          "swim_walk": {
            "startRow": 58,
            "frameCount": 6,
            "fps": 8.0
          },
          "swim_attack": {
            "startRow": 64,
            "frameCount": 6,
            "fps": 8.0
          },
          "swim_hurt": {
            "startRow": 70,
            "frameCount": 7,
            "fps": 6.0
          },
          "swim_idle": {
            "startRow": 77,
            "frameCount": 7,
            "fps": 4.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 90,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : raven.e3 (world_size: 6.5)",
        "textureParts": [
          {
            "name": "rav_arm1",
            "width": 64,
            "height": 64
          },
          {
            "name": "rav_ft1",
            "width": 64,
            "height": 64
          },
          {
            "name": "rav_hed1",
            "width": 64,
            "height": 64
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\raven.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "raven4",
      "name": "RAVEN-4 SHADOW CYBORG",
      "category": "infantry",
      "archetype": "cyborg-trooper",
      "worldSizeRaw": 6.5,
      "dimensionsMeters": [
        0.99,
        1.17,
        0.2
      ],
      "maxDimensionMeters": 1.17,
      "pedestalFitScale": 1.0,
      "hp": 120,
      "maxHp": 120,
      "speed": 4,
      "moveSpeed": 4,
      "attackDamage": 15,
      "fireRate": 1.2,
      "attackRange": 14,
      "projectileType": "bullet",
      "projectileSpeed": 35,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": false,
      "color": 2241365,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 50
        },
        {
          "item": "spread-ammo",
          "weight": 30
        },
        {
          "item": "energy-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "void_black",
        "plasma_blue"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_raven4_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_raven4.png",
        "frameCount": 720,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death",
          "crouch_idle",
          "crouch_walk",
          "crouch_run",
          "crouch_attack",
          "crouch_hurt",
          "swim_walk",
          "swim_attack",
          "swim_hurt",
          "swim_idle"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 4,
            "fps": 4.0
          },
          "walk": {
            "startRow": 4,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 12,
            "frameCount": 8,
            "fps": 10.0
          },
          "attack": {
            "startRow": 20,
            "frameCount": 7,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 27,
            "frameCount": 2,
            "fps": 6.0
          },
          "death": {
            "startRow": 84,
            "frameCount": 6,
            "fps": 6.0
          },
          "crouch_idle": {
            "startRow": 42,
            "frameCount": 1,
            "fps": 4.0
          },
          "crouch_walk": {
            "startRow": 43,
            "frameCount": 8,
            "fps": 8.0
          },
          "crouch_run": {
            "startRow": 51,
            "frameCount": 5,
            "fps": 10.0
          },
          "crouch_attack": {
            "startRow": 35,
            "frameCount": 7,
            "fps": 8.0
          },
          "crouch_hurt": {
            "startRow": 56,
            "frameCount": 2,
            "fps": 6.0
          },
          "swim_walk": {
            "startRow": 58,
            "frameCount": 6,
            "fps": 8.0
          },
          "swim_attack": {
            "startRow": 64,
            "frameCount": 6,
            "fps": 8.0
          },
          "swim_hurt": {
            "startRow": 70,
            "frameCount": 7,
            "fps": 6.0
          },
          "swim_idle": {
            "startRow": 77,
            "frameCount": 7,
            "fps": 4.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 90,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : raven4.e3 (world_size: 6.5)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\raven4.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "riot",
      "name": "RIOT SUPPRESSION ENFORCER",
      "category": "infantry",
      "archetype": "riot-trooper",
      "worldSizeRaw": 6.5,
      "dimensionsMeters": [
        0.99,
        1.17,
        0.2
      ],
      "maxDimensionMeters": 1.17,
      "pedestalFitScale": 1.0,
      "hp": 140,
      "maxHp": 140,
      "speed": 3,
      "moveSpeed": 3,
      "attackDamage": 20,
      "fireRate": 1,
      "attackRange": 8,
      "projectileType": "shotgun",
      "projectileSpeed": 30,
      "shieldCapacity": 100,
      "hasRiotShield": true,
      "isFlying": false,
      "isTurret": false,
      "color": 2241416,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 40
        },
        {
          "item": "missile-ammo",
          "weight": 35
        },
        {
          "item": "reserve-tank",
          "weight": 15
        },
        {
          "item": "keycard-blue",
          "weight": 10
        }
      ],
      "swatches": [
        "standard",
        "riot_police",
        "hazard_yellow"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_riot_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_riot.png",
        "frameCount": 192,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 9,
            "frameCount": 8,
            "fps": 10.0
          },
          "attack": {
            "startRow": 17,
            "frameCount": 3,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 20,
            "frameCount": 1,
            "fps": 6.0
          },
          "death": {
            "startRow": 22,
            "frameCount": 2,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 24,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : riot.e3 (world_size: 6.5)",
        "textureParts": [
          {
            "name": "riot1",
            "width": 64,
            "height": 64
          },
          {
            "name": "riot2",
            "width": 64,
            "height": 64
          },
          {
            "name": "riot3",
            "width": 64,
            "height": 64
          },
          {
            "name": "riotdedb",
            "width": 128,
            "height": 128
          },
          {
            "name": "riotdedf",
            "width": 128,
            "height": 128
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\riot.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "rival",
      "name": "RIVAL NEMESIS AGENT",
      "category": "infantry",
      "archetype": "cyborg-trooper",
      "worldSizeRaw": 8.0,
      "dimensionsMeters": [
        1.22,
        1.44,
        0.2
      ],
      "maxDimensionMeters": 1.44,
      "pedestalFitScale": 1.0,
      "hp": 220,
      "maxHp": 220,
      "speed": 4,
      "moveSpeed": 4,
      "attackDamage": 15,
      "fireRate": 1.2,
      "attackRange": 14,
      "projectileType": "bullet",
      "projectileSpeed": 35,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": false,
      "color": 16711748,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 50
        },
        {
          "item": "spread-ammo",
          "weight": 30
        },
        {
          "item": "energy-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "nemesis_gold",
        "dark_matter"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_rival_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_rival.png",
        "frameCount": 184,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 9,
            "frameCount": 6,
            "fps": 10.0
          },
          "attack": {
            "startRow": 15,
            "frameCount": 1,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 16,
            "frameCount": 1,
            "fps": 6.0
          },
          "death": {
            "startRow": 17,
            "frameCount": 6,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 23,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : rival.e3 (world_size: 8.0)",
        "textureParts": [
          {
            "name": "rivalmv1",
            "width": 256,
            "height": 256
          },
          {
            "name": "rivalmv2",
            "width": 256,
            "height": 256
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\rival.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "rivalmv1",
      "name": "RIVAL COMBAT STANCE ALPHA",
      "category": "infantry",
      "archetype": "cyborg-trooper",
      "worldSizeRaw": 8.0,
      "dimensionsMeters": [
        1.22,
        1.44,
        0.2
      ],
      "maxDimensionMeters": 1.44,
      "pedestalFitScale": 1.0,
      "hp": 220,
      "maxHp": 220,
      "speed": 4,
      "moveSpeed": 4,
      "attackDamage": 15,
      "fireRate": 1.2,
      "attackRange": 14,
      "projectileType": "bullet",
      "projectileSpeed": 35,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": false,
      "color": 16720469,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 50
        },
        {
          "item": "spread-ammo",
          "weight": 30
        },
        {
          "item": "energy-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "crimson",
        "gold"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_rivalmv1_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_rivalmv1.png",
        "frameCount": 40,
        "states": [
          "idle",
          "walk",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4
          },
          "walk": {
            "startRow": 1,
            "frameCount": 1,
            "fps": 6
          },
          "attack": {
            "startRow": 2,
            "frameCount": 1,
            "fps": 6
          },
          "hurt": {
            "startRow": 3,
            "frameCount": 1,
            "fps": 6
          },
          "death": {
            "startRow": 4,
            "frameCount": 1,
            "fps": 6
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 5,
        "authenticDecoded": false
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : rivalmv1.e3 (world_size: 8.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": null,
        "huffmanDecoded": false
      }
    },
    {
      "id": "rivalmv2",
      "name": "RIVAL COMBAT STANCE BETA",
      "category": "infantry",
      "archetype": "cyborg-trooper",
      "worldSizeRaw": 8.0,
      "dimensionsMeters": [
        1.22,
        1.44,
        0.2
      ],
      "maxDimensionMeters": 1.44,
      "pedestalFitScale": 1.0,
      "hp": 220,
      "maxHp": 220,
      "speed": 4,
      "moveSpeed": 4,
      "attackDamage": 15,
      "fireRate": 1.2,
      "attackRange": 14,
      "projectileType": "bullet",
      "projectileSpeed": 35,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": false,
      "color": 16729190,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 50
        },
        {
          "item": "spread-ammo",
          "weight": 30
        },
        {
          "item": "energy-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "crimson",
        "gold"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_rivalmv2_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_rivalmv2.png",
        "frameCount": 40,
        "states": [
          "idle",
          "walk",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4
          },
          "walk": {
            "startRow": 1,
            "frameCount": 1,
            "fps": 6
          },
          "attack": {
            "startRow": 2,
            "frameCount": 1,
            "fps": 6
          },
          "hurt": {
            "startRow": 3,
            "frameCount": 1,
            "fps": 6
          },
          "death": {
            "startRow": 4,
            "frameCount": 1,
            "fps": 6
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 5,
        "authenticDecoded": false
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : rivalmv2.e3 (world_size: 8.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": null,
        "huffmanDecoded": false
      }
    },
    {
      "id": "science",
      "name": "FACILITY COMBAT SCIENTIST",
      "category": "infantry",
      "archetype": "cyborg-trooper",
      "worldSizeRaw": 6.5,
      "dimensionsMeters": [
        0.99,
        1.17,
        0.2
      ],
      "maxDimensionMeters": 1.17,
      "pedestalFitScale": 1.0,
      "hp": 75,
      "maxHp": 75,
      "speed": 4,
      "moveSpeed": 4,
      "attackDamage": 15,
      "fireRate": 1.2,
      "attackRange": 14,
      "projectileType": "bullet",
      "projectileSpeed": 35,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": false,
      "color": 14540253,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 50
        },
        {
          "item": "spread-ammo",
          "weight": 30
        },
        {
          "item": "energy-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "hazmat_yellow",
        "biohazard_green"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_science_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_science.png",
        "frameCount": 88,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "attack": {
            "startRow": 9,
            "frameCount": 2,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "death": {
            "startRow": 9,
            "frameCount": 2,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 256,
        "frameHeight": 256,
        "sheetCols": 8,
        "sheetRows": 11,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : science.e3 (world_size: 6.5)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\science.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "scubagun",
      "name": "AUTOMATED SUB-AQUATIC TURRET",
      "category": "turret",
      "archetype": "sniper_turret",
      "worldSizeRaw": 4.0,
      "dimensionsMeters": [
        0.77,
        0.9,
        0.2
      ],
      "maxDimensionMeters": 0.9,
      "pedestalFitScale": 1.0,
      "hp": 130,
      "maxHp": 130,
      "speed": 0,
      "moveSpeed": 0,
      "attackDamage": 12,
      "fireRate": 3,
      "attackRange": 22,
      "projectileType": "sniper-beam",
      "projectileSpeed": 45,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": true,
      "color": 4482696,
      "lootTable": [
        {
          "item": "energy-tank",
          "weight": 50
        },
        {
          "item": "cannon-ammo",
          "weight": 30
        },
        {
          "item": "reserve-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "steel_grey",
        "hazard_stripe"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_scubagun_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_scubagun.png",
        "frameCount": 64,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 8,
            "fps": 4.0
          },
          "walk": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "run": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "attack": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 8,
            "fps": 4.0
          },
          "death": {
            "startRow": 0,
            "frameCount": 8,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 256,
        "frameHeight": 256,
        "sheetCols": 8,
        "sheetRows": 8,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : scubagun.e3 (world_size: 4.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\scubagun.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "seamon",
      "name": "SEAMON AQUATIC BEAST",
      "category": "fauna",
      "archetype": "melee_swarmer",
      "worldSizeRaw": 5.0,
      "dimensionsMeters": [
        0.77,
        0.9,
        0.2
      ],
      "maxDimensionMeters": 0.9,
      "pedestalFitScale": 1.0,
      "hp": 120,
      "maxHp": 120,
      "speed": 7,
      "moveSpeed": 7,
      "attackDamage": 12,
      "fireRate": 2,
      "attackRange": 3,
      "projectileType": "melee-strike",
      "projectileSpeed": 25,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": true,
      "isTurret": false,
      "color": 21879,
      "lootTable": [
        {
          "item": "energy-tank",
          "weight": 60
        },
        {
          "item": "health-tank",
          "weight": 40
        }
      ],
      "swatches": [
        "standard",
        "abyssal_green",
        "shadow_blue"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_seamon_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_seamon.png",
        "frameCount": 96,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 4,
            "fps": 4.0
          },
          "walk": {
            "startRow": 4,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 4,
            "frameCount": 8,
            "fps": 8.0
          },
          "attack": {
            "startRow": 4,
            "frameCount": 8,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 4,
            "fps": 4.0
          },
          "death": {
            "startRow": 4,
            "frameCount": 8,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 256,
        "frameHeight": 256,
        "sheetCols": 8,
        "sheetRows": 12,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : seamon.e3 (world_size: 5.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\seamon.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "sight",
      "name": "OPTICAL SNIPER TURRET",
      "category": "turret",
      "archetype": "sniper_turret",
      "worldSizeRaw": 1.6640000343322754,
      "dimensionsMeters": [
        0.77,
        0.9,
        0.2
      ],
      "maxDimensionMeters": 0.9,
      "pedestalFitScale": 1.0,
      "hp": 120,
      "maxHp": 120,
      "speed": 0,
      "moveSpeed": 0,
      "attackDamage": 12,
      "fireRate": 3,
      "attackRange": 22,
      "projectileType": "sniper-beam",
      "projectileSpeed": 45,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": true,
      "color": 16720384,
      "lootTable": [
        {
          "item": "energy-tank",
          "weight": 50
        },
        {
          "item": "cannon-ammo",
          "weight": 30
        },
        {
          "item": "reserve-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "crimson_eye",
        "emerald_lens"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_sight_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_sight.png",
        "frameCount": 40,
        "states": [
          "idle",
          "walk",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4
          },
          "walk": {
            "startRow": 1,
            "frameCount": 1,
            "fps": 6
          },
          "attack": {
            "startRow": 2,
            "frameCount": 1,
            "fps": 6
          },
          "hurt": {
            "startRow": 3,
            "frameCount": 1,
            "fps": 6
          },
          "death": {
            "startRow": 4,
            "frameCount": 1,
            "fps": 6
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 5,
        "authenticDecoded": false
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : sight.e3 (world_size: 1.6640000343322754)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": null,
        "huffmanDecoded": false
      }
    },
    {
      "id": "spider",
      "name": "ARACHNID WALL SWARMER",
      "category": "fauna",
      "archetype": "melee_swarmer",
      "worldSizeRaw": 4.0,
      "dimensionsMeters": [
        0.68,
        0.8,
        0.2
      ],
      "maxDimensionMeters": 0.8,
      "pedestalFitScale": 1.0,
      "hp": 45,
      "maxHp": 45,
      "speed": 7,
      "moveSpeed": 7,
      "attackDamage": 12,
      "fireRate": 2,
      "attackRange": 3,
      "projectileType": "melee-strike",
      "projectileSpeed": 25,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": true,
      "isTurret": false,
      "color": 8930338,
      "lootTable": [
        {
          "item": "energy-tank",
          "weight": 60
        },
        {
          "item": "health-tank",
          "weight": 40
        }
      ],
      "swatches": [
        "standard",
        "chitin_brown",
        "venom_green"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_spider_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_spider.png",
        "frameCount": 96,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "attack": {
            "startRow": 9,
            "frameCount": 2,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 11,
            "frameCount": 1,
            "fps": 6.0
          },
          "death": {
            "startRow": 11,
            "frameCount": 1,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 12,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : spider.e3 (world_size: 4.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\spider.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "tank",
      "name": "HEAVY ARMORED HOVER TANK",
      "category": "heavy",
      "archetype": "heavy_enforcer",
      "worldSizeRaw": 13.0,
      "dimensionsMeters": [
        2.21,
        2.6,
        0.2
      ],
      "maxDimensionMeters": 2.6,
      "pedestalFitScale": 0.77,
      "hp": 400,
      "maxHp": 400,
      "speed": 3,
      "moveSpeed": 3,
      "attackDamage": 20,
      "fireRate": 1,
      "attackRange": 8,
      "projectileType": "heavy-shot",
      "projectileSpeed": 30,
      "shieldCapacity": 100,
      "hasRiotShield": true,
      "isFlying": false,
      "isTurret": false,
      "color": 4478276,
      "lootTable": [
        {
          "item": "health-tank",
          "weight": 40
        },
        {
          "item": "missile-ammo",
          "weight": 35
        },
        {
          "item": "reserve-tank",
          "weight": 15
        },
        {
          "item": "keycard-blue",
          "weight": 10
        }
      ],
      "swatches": [
        "standard",
        "panzer_grey",
        "desert_camo"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_tank_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_tank.png",
        "frameCount": 8,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "run": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "attack": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          },
          "hurt": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "death": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 1,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : tank.e3 (world_size: 13.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": "pkdtexts\\tank.e3",
        "huffmanDecoded": true
      }
    },
    {
      "id": "trigbomb",
      "name": "PROXIMITY DETONATION MINE",
      "category": "turret",
      "archetype": "defense-turret",
      "worldSizeRaw": 1.0,
      "dimensionsMeters": [
        0.77,
        0.9,
        0.2
      ],
      "maxDimensionMeters": 0.9,
      "pedestalFitScale": 1.0,
      "hp": 30,
      "maxHp": 30,
      "speed": 0,
      "moveSpeed": 0,
      "attackDamage": 12,
      "fireRate": 3,
      "attackRange": 20,
      "projectileType": "turret-laser",
      "projectileSpeed": 45,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": false,
      "isTurret": true,
      "color": 16755200,
      "lootTable": [
        {
          "item": "energy-tank",
          "weight": 50
        },
        {
          "item": "cannon-ammo",
          "weight": 30
        },
        {
          "item": "reserve-tank",
          "weight": 20
        }
      ],
      "swatches": [
        "standard",
        "hazard_stripe",
        "black_stealth"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_trigbomb_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_trigbomb.png",
        "frameCount": 40,
        "states": [
          "idle",
          "walk",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4
          },
          "walk": {
            "startRow": 1,
            "frameCount": 1,
            "fps": 6
          },
          "attack": {
            "startRow": 2,
            "frameCount": 1,
            "fps": 6
          },
          "hurt": {
            "startRow": 3,
            "frameCount": 1,
            "fps": 6
          },
          "death": {
            "startRow": 4,
            "frameCount": 1,
            "fps": 6
          }
        },
        "angles": 8,
        "frameWidth": 128,
        "frameHeight": 128,
        "sheetCols": 8,
        "sheetRows": 5,
        "authenticDecoded": false
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : trigbomb.e3 (world_size: 1.0)",
        "textureParts": [],
        "resolved": false,
        "pkdTexture": null,
        "huffmanDecoded": false
      }
    },
    {
      "id": "waterbot",
      "name": "WATERBOT SUBMERSIBLE DRONE",
      "category": "fauna",
      "archetype": "melee_swarmer",
      "worldSizeRaw": 10.0,
      "dimensionsMeters": [
        1.27,
        1.5,
        0.2
      ],
      "maxDimensionMeters": 1.5,
      "pedestalFitScale": 1.0,
      "hp": 100,
      "maxHp": 100,
      "speed": 7,
      "moveSpeed": 7,
      "attackDamage": 12,
      "fireRate": 2,
      "attackRange": 3,
      "projectileType": "melee-strike",
      "projectileSpeed": 25,
      "shieldCapacity": 0,
      "hasRiotShield": false,
      "isFlying": true,
      "isTurret": false,
      "color": 26282,
      "lootTable": [
        {
          "item": "energy-tank",
          "weight": 60
        },
        {
          "item": "health-tank",
          "weight": 40
        }
      ],
      "swatches": [
        "standard",
        "deep_sea_blue",
        "abyssal_black"
      ],
      "billboard": {
        "sheetFile": "/assets/textures/sprites/enemy_waterbot_sheet.png",
        "previewFile": "/assets/textures/sprites/enemy_waterbot.png",
        "frameCount": 96,
        "states": [
          "idle",
          "walk",
          "run",
          "attack",
          "hurt",
          "death"
        ],
        "animations": {
          "idle": {
            "startRow": 0,
            "frameCount": 1,
            "fps": 4.0
          },
          "walk": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "run": {
            "startRow": 1,
            "frameCount": 8,
            "fps": 8.0
          },
          "attack": {
            "startRow": 9,
            "frameCount": 1,
            "fps": 8.0
          },
          "hurt": {
            "startRow": 10,
            "frameCount": 1,
            "fps": 6.0
          },
          "death": {
            "startRow": 11,
            "frameCount": 1,
            "fps": 6.0
          }
        },
        "angles": 8,
        "frameWidth": 256,
        "frameHeight": 256,
        "sheetCols": 8,
        "sheetRows": 12,
        "authenticDecoded": true
      },
      "provenance": {
        "sourceTag": "ESOTERIA/SPRITES.E3 : waterbot.e3 (world_size: 10.0)",
        "textureParts": [
          {
            "name": "wtrb_arm",
            "width": 64,
            "height": 64
          },
          {
            "name": "wtrb_leg",
            "width": 64,
            "height": 64
          },
          {
            "name": "wtrb_shr",
            "width": 64,
            "height": 64
          }
        ],
        "resolved": true,
        "pkdTexture": "pkdtexts\\waterbot.e3",
        "huffmanDecoded": true
      }
    }
  ]
}
